export default "__VITE_PUBLIC_ASSET__151daa18__"